// Web shim for react-native-draggable-flatlist — falls back to a regular FlatList
import React from 'react';
import { FlatList } from 'react-native';

function DraggableFlatList({ data, renderItem, keyExtractor, onDragEnd, ...props }) {
  // On web, just render a regular FlatList (drag-to-reorder not supported)
  const wrappedRenderItem = (info) => {
    return renderItem({
      ...info,
      drag: () => {},
      isActive: false,
    });
  };

  return (
    <FlatList
      data={data}
      renderItem={wrappedRenderItem}
      keyExtractor={keyExtractor}
      {...props}
    />
  );
}

export function ScaleDecorator({ children }) {
  return children;
}

export default DraggableFlatList;
